import { Tooltip } from "@heroui/react";
import { cn } from "@/utils/cn";
import { User } from "lucide-react";

const ExtraCountAvatar = ({ count, members = [], size = "size-8" }) => {
  if (!count || count <= 0) return null;

  const names = members.map((m) => m.fullname ?? m.member_fullname).filter(Boolean);

  return (
    <Tooltip placement="top" delay={300}>
      <Tooltip.Trigger>
        <div
          className={cn(
            "rounded-full border bg-default text-default-foreground text-[10px] flex items-center justify-center shrink-0",
            size,
          )}
        >
          +{count}
        </div>
      </Tooltip.Trigger>
      <Tooltip.Content showArrow className="max-w-56">
        {names.length > 0 ? (
          <div className="flex flex-col gap-1">
            {names.map((name, i) => (
              <div className="flex items-center capitalize font-medium gap-1">
                <User size={16} strokeWidth={1.5} className="text-accent" />
                {name}
              </div>
            ))}
          </div>
        ) : (
          <span className="text-[10px]">+{count} more</span>
        )}
      </Tooltip.Content>
    </Tooltip>
  );
};

export default ExtraCountAvatar;
